import React from 'react';

import {
    BrowserExtensionIcon,
    CreateFactCardsIcon,
    ElevatedCollaborationIcon,
    QuizzingTrumpsLearningIcon,
    KnowledgeSimplifiedIcon,
    OnlineDatabasesIcon,
    MobileCardsQuizIcon,
    NewArticleAlertsIcon,
    AnnotationExtractorIcon,
    ReferenceManagingIcon,
    SafetyFirstIcon,
    VisualLibraryIcon
} from 'ui/icons';

import {
    colorBgPrimaryOne,
    colorBgPrimaryTwo,
    colorBgPrimaryThree,
    colorBgPrimaryFour,
    colorBgPrimaryFive,
    colorBgPrimarySix,
    colorBgPrimarySeven,
    colorBgPrimaryEight,
    colorBgPrimaryNine,
    colorBgPrimaryTen,
    colorBgPrimaryEleven,
    colorBgPrimaryTwelwe
} from './knowledge-hub-data.module.scss';

export type KnowledgeItem = {
    icon: React.JSX.Element;
    title: string;
    text: string;
    color: string;
};

export const knowledgeItems: KnowledgeItem[] = [
    {
        title: 'Visual Library',
        icon: <VisualLibraryIcon />,
        text: 'A visually optimized and structured library. Find your stuff in seconds.',
        color: colorBgPrimaryOne
    },
    {
        title: 'Online Databases',
        icon: <OnlineDatabasesIcon />,
        text: 'Access millions of published articles and add your hits to your library.',
        color: colorBgPrimaryTwo
    },
    {
        title: 'Browser Extension',
        icon: <BrowserExtensionIcon />,
        text: 'Download PDFs and websites, and add references to your library.',
        color: colorBgPrimaryThree
    },
    {
        title: 'Reference Managing',
        icon: <ReferenceManagingIcon />,
        text: 'Format in-text citations and your bibliography in a super easy way.',
        color: colorBgPrimaryFour
    },
    {
        title: 'New Article Alerts',
        icon: <NewArticleAlertsIcon />,
        text: 'Create searches for your topics of interest. Much better than eTOCs.',
        color: colorBgPrimaryFive
    },
    {
        title: 'Annotation Extractor',
        icon: <AnnotationExtractorIcon />,
        text: 'Turn annotations into cards or quizzes - with a link back to the PDF.',
        color: colorBgPrimarySix
    },
    {
        title: 'Create Fact Cards',
        icon: <CreateFactCardsIcon />,
        text: 'Bring information together that belong together. In their context.',
        color: colorBgPrimarySeven
    },
    {
        title: 'Knowledge, Simplified',
        icon: <KnowledgeSimplifiedIcon />,
        text: 'Reorganise, collect, connect, build, and exchange knowledge.',
        color: colorBgPrimaryEight
    },
    {
        title: 'Elevated Collaboration',
        icon: <ElevatedCollaborationIcon />,
        text: 'Share and collaborate with your peers in groups. Build a community.',
        color: colorBgPrimaryNine
    },
    {
        title: 'Quizzing trumps learning',
        icon: <QuizzingTrumpsLearningIcon />,
        text: 'Create quizzes instantly from your annotations or fact cards.',
        color: colorBgPrimaryTen
    },
    {
        title: 'Mobile Cards & Quiz',
        icon: <MobileCardsQuizIcon />,
        text: 'Anytime. Anywhere. Read and learn, using your smartphone.',
        color: colorBgPrimaryEleven
    },
    {
        title: 'Safety First',
        icon: <SafetyFirstIcon />,
        text: 'Export your Elumity content to your local storage anytime.',
        color: colorBgPrimaryTwelwe
    }
];
